import { ApiClient } from '../ApiClient.js';

export class CommissionsApiService {
    static async list({ page = 1, per_page = 50, user_id = null, deal_id = null } = {}) {
        const params = { page, per_page };
        if (user_id) params.user_id = user_id;
        if (deal_id) params.deal_id = deal_id;
        return ApiClient.get('/api/v1/commissions', params);
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/commissions', payload);
    }

    static async update(commissionId, payload) {
        return ApiClient.patch(`/api/v1/commissions/${encodeURIComponent(commissionId)}`, payload);
    }
}
